import PeriodDetails from '@/components/periodDetails/PeriodDetails';
import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';

function PeriodDetailsPage() {
  return (
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        mr: 2,
      }}
    >
      <PeriodDetails />
      <Outlet />
    </Box>
  );
}
export default PeriodDetailsPage;
